import { memo, useEffect, useState } from 'react';
import { Divider, IconButton, Stack, TabProps, StackProps } from '@mui/material';
import Tab from 'components/Common/Tab';
import ImageUploadContainer from 'components/Account/ImageUploadContainer';
import ImageLibrary from 'components/Common/ImageList';
import MuiLoader from 'components/Common/Loader';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

interface ChangePhotoProp {
    imgValue: string;
    setImgValue: Function;
    isLoading?: boolean;
    onRemoveClick?: Function;
    tabProps?: TabProps;
    stackProps?: StackProps;
}

const ImagesData = [
    {
        img: require('../../assets/AV1.png'),
        title: 'AV1',
    },
    {
        img: require('../../assets/AV2.png'),
        title: 'AV2',
    },
    {
        img: require('../../assets/AV3.png'),
        title: 'AV3',
    },
    {
        img: require('../../assets/AV4.png'),
        title: 'AV4',
    },
    {
        img: require('../../assets/AV5.png'),
        title: 'AV5',
    },
    {
        img: require('../../assets/AV6.png'),
        title: 'AV6',
    },
    {
        img: require('../../assets/AV7.png'),
        title: 'AV7',
    },
    {
        img: require('../../assets/AV8.png'),
        title: 'AV8',
    },
    {
        img: require('../../assets/AV9.png'),
        title: 'AV9',
    },
    {
        img: require('../../assets/B1.jpg'),
        title: 'B1',
    },
    {
        img: require('../../assets/B2.jpg'),
        title: 'B2',
    },
    {
        img: require('../../assets/B3.jpg'),
        title: 'B3',
    },
    {
        img: require('../../assets/B4.jpg'),
        title: 'B4',
    },
    {
        img: require('../../assets/B5.jpg'),
        title: 'B5',
    },
    {
        img: require('../../assets/B6.jpg'),
        title: 'B6',
    },
    {
        img: require('../../assets/B7.jpeg'),
        title: 'B7',
    },
    {
        img: require('../../assets/B8.jpeg'),
        title: 'B8',
    },
    {
        img: require('../../assets/B9.jpg'),
        title: 'B9',
    },
];

function ChangePhoto({ imgValue, setImgValue, isLoading, onRemoveClick, tabProps, stackProps }: ChangePhotoProp) {
    const [tab, setTab] = useState('uploadimage');
    const [clickedIndex, setClickedIndex] = useState(null);

    useEffect(() => {
        setTab('uploadimage');
    }, [imgValue]);

    const setTabValue = (value: string) => {
        setTab(value);
    };

    const getBlobUrl = (img: any) => {
        if (!img) return '';
        if (typeof img === 'string') return img;
        return URL.createObjectURL(img);
    };
    const handleRemoveClick = () => {
        if (onRemoveClick) {
            return onRemoveClick();
        }
        setImgValue('');
    };
    if (imgValue) {
        return (
            <Stack width="100%" alignItems="center" justifyContent="center">
                <IconButton sx={{ ml: 30 }}>
                    <RemoveCircleOutlineIcon onClick={handleRemoveClick} />
                </IconButton>
                <img src={getBlobUrl(imgValue)} alt="basket logo" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />
            </Stack>
        );
    }

    return (
        <Stack width="100%">
            <Tab
                tabs={[
                    { value: 'uploadimage', label: 'Upload Image' },
                    { value: 'imagelibrary', label: 'Image Library' },
                ]}
                tabValue={tab}
                setTabValue={setTabValue}
                {...tabProps}
            />
            <Divider />
            {isLoading && (
                <Stack width="100%" height="300px" alignItems="center" justifyContent="center">
                    <MuiLoader loading={isLoading} />
                </Stack>
            )}
            {!isLoading && (
                <Stack {...stackProps}>
                    {tab !== 'uploadimage' ? (
                        <ImageLibrary
                            setImgValue={setImgValue}
                            itemData={ImagesData}
                            clickedIndex={clickedIndex}
                            setClickedIndex={setClickedIndex}
                        />
                    ) : (
                        <ImageUploadContainer imgValue={imgValue} setImgValue={setImgValue} />
                    )}
                </Stack>
            )}
        </Stack>
    );
}

export default memo(ChangePhoto);
